export const endpoints = {
  savedReportEvaluation: 'dashboard/report/evaluation',
  savedReportsOptions: 'validFavourite'
};
